var map = {
	"./barbecue/static.svg": [
		"XHBl",
		18
	],
	"./dog/static.svg": [
		"5f55",
		19
	],
	"./male-walking/static.svg": [
		"iOfK",
		20
	],
	"./skyping/static.svg": [
		"TrRk",
		21
	],
	"./tree/static.svg": [
		"Z/I2",
		22
	],
	"./ufo-centered/static.svg": [
		"fr8O",
		23
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "z3H2";
module.exports = webpackAsyncContext;